import { z } from "zod";

import { CurrencyCodelist } from "@/data/codelists";
import { PayCode } from "@/data/pay-codes";

export const TimeReportProjectPayCode = z.object({
  payCode: PayCode,
  reportedTime: z.number(),
  currency: CurrencyCodelist,
  cost: z.number(),
});

export type TimeReportProjectPayCode = z.infer<typeof TimeReportProjectPayCode>;
